module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "rounded-lg",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v("Nachrichten")]), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "height": "200px",
      "items": _vm.nachrichten,
      "fixed-header": "",
      "hide-default-header": "",
      "hide-default-footer": "",
      "items-per-page": -1,
      "no-data-text": "Keine Nachrichten vorhanden"
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          on: {
            "click": function($event) {
              _vm.nachricht = item
            }
          }
        }, [_c('v-list', {
          staticClass: "py-0 ma-1 font-weight-bold elevation-0",
          attrs: {
            "three-line": ""
          }
        }, [_c('v-list-item', [_c('v-list-item-avatar', [_c('v-img', {
          attrs: {
            "src": '/static/wappen_klein.webp'
          }
        })], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', {
          domProps: {
            "innerHTML": _vm._s(item.von)
          }
        }), _vm._v(" "), _c('v-list-item-subtitle', {
          domProps: {
            "innerHTML": _vm._s(item.text)
          }
        })], 1), _vm._v(" "), _c('v-list-item-action', [_c('div', [_vm._v(_vm._s(_vm.$filters.date(item.datum, "DD.MM.YYYY")))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$filters.date(item.datum, "hh:mm")) + " Uhr")])])], 1)], 1)], 1)]
      }
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dd130a0a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module_klein/mailsListe.vue
// module id = 815
// module chunks = 15